import { getAccessToken } from "./utils";
import axios from "axios";
import moment from "moment-timezone";
import { getDateParamsTrends } from "./utils";
import { getUrl } from "./urls";

export const YOUTUBE_TRENDS_PENDING = "YOUTUBE_TRENDS_PENDING";
export const YOUTUBE_TRENDS_FULFILLED = "YOUTUBE_TRENDS_FULFILLED";
export const YOUTUBE_TRENDS_REJECTED = "YOUTUBE_TRENDS_REJECTED";
export const YOUTUBE_SUBSCRIBERS_PENDING = "YOUTUBE_SUBSCRIBERS_PENDING";
export const YOUTUBE_SUBSCRIBERS_FULFILLED = "YOUTUBE_SUBSCRIBERS_FULFILLED";
export const YOUTUBE_SUBSCRIBERS_REJECTED = "YOUTUBE_SUBSCRIBERS_REJECTED";
export const HOT_SEARCHES_PENDING = "HOT_SEARCHES_PENDING";
export const HOT_SEARCHES_FULFILLED = "HOT_SEARCHES_FULFILLED";
export const HOT_SEARCHES_REJECTED = "HOT_SEARCHES_REJECTED";
export const SAVED_SEARCHES_KEYWORD = "SAVED_SEARCHES_KEYWORD";
export const GOOGLE_TRENDS_FOR_KEYWORDS = "GOOGLE_TRENDS_FOR_KEYWORDS";
export const TOP_TRENDS_PENDING = "TOP_TRENDS_PENDING";
export const TOP_TRENDS_FULFILLED = "TOP_TRENDS_FULFILLED";
export const TOP_TRENDS_REJECTED = "TOP_TRENDS_REJECTED";
export const LOCAL_TWITTER_TRENDS_FULFILLED = "LOCAL_TWITTER_TRENDS_FULFILLED";
export const LOCAL_TWITTER_TRENDS_PENDING = "LOCAL_TWITTER_TRENDS_PENDING";
export const LOCAL_TWITTER_TRENDS_REJECTED = "LOCAL_TWITTER_TRENDS_REJECTED";
export const GLOBAL_TWITTER_TRENDS_FULFILLED = "GLOBAL_TWITTER_TRENDS_FULFILLED";
export const GLOBAL_TWITTER_TRENDS_PENDING = "GLOBAL_TWITTER_TRENDS_PENDING";
export const GLOBAL_TWITTER_TRENDS_REJECTED = "GLOBAL_TWITTER_TRENDS_REJECTED";
export const TRENDS_OVER_TIME_FULFILLED = "TRENDS_OVER_TIME_FULFILLED";
export const TRENDS_OVER_TIME_PENDING = "TRENDS_OVER_TIME_PENDING";
export const TRENDS_OVER_TIME_REJECTED = "TRENDS_OVER_TIME_REJECTED";
export const GET_COMPARISONS_FULFILLED = "GET_COMPARISONS_FULFILLED";
export const GET_COMPARISONS_PENDING = "GET_COMPARISONS_PENDING";
export const GET_COMPARISONS_REJECTED = "GET_COMPARISONS_REJECTED";
export const TOGGLE_TRENDS_DURATION_SHOW = "TOGGLE_TRENDS_DURATION_SHOW";
export const TOGGLE_TRENDS_COUNTRY_SHOW = "TOGGLE_TRENDS_COUNTRY_SHOW";
export const UPDATE_TRENDS_DURATION = "UPDATE_TRENDS_DURATION";
export const SET_TRENDS_TAB_INDEX = "SET_TRENDS_TAB_INDEX";

export function setTrendsTabIndex(tabIndex) {
    return function (dispatch) {
        dispatch({
            type: SET_TRENDS_TAB_INDEX,
            payload: tabIndex,
        });
    };
}

export function toggleTrendsDurationShow(show) {
    return {
        type: TOGGLE_TRENDS_DURATION_SHOW,
        payload: show,
    };
}

export function toggleTrendsCountryShow(show) {
    return {
        type: TOGGLE_TRENDS_COUNTRY_SHOW,
        payload: show,
    };
}

export function updateTrendsDuration(dispatch, duration) {
    dispatch({
        type: "UPDATE_TRENDS_DURATION",
        payload: duration,
    });
}

export const fetchYoutubeTrendsData = (dispatch, country) => {
    let params = new URLSearchParams();
    let url = `${getUrl(
        "youtube_trends",
    )}type=videos&params=part%3Did%2Csnippet%2Cstatistics%26regionCode%3D${country}%26order%3Ddate%26maxResults%3D10%26chart%3DmostPopular&access-token=${getAccessToken()}`;

    dispatch({ type: YOUTUBE_TRENDS_PENDING });
    axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: params,
    })
        .then((res) => {
            if (res.status === 200) {
                console.log("res", res);
                if (!res.data.error)
                    dispatch({
                        type: YOUTUBE_TRENDS_FULFILLED,
                        payload: res.data.data.videos.items,
                    });
                else
                    dispatch({
                        type: YOUTUBE_TRENDS_FULFILLED,
                        payload: [],
                    });
            } else {
                dispatch({ type: YOUTUBE_TRENDS_REJECTED });
            }
        })
        .catch((err) => {
            console.log(err);
            dispatch({ type: YOUTUBE_TRENDS_REJECTED });
        });
};
export const fetchYoutubeSubscribersCount = (dispatch, channelIds) => {
    let url = getUrl("youtube_subscriber");
    dispatch({ type: YOUTUBE_SUBSCRIBERS_PENDING });
    axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
        },
        data: {
            channelIds: channelIds,
        },
    })
        .then((res) => {
            dispatch({
                type: YOUTUBE_SUBSCRIBERS_FULFILLED,
                payload: res.data,
            });
        })
        .catch((err) => {
            console.log(err);
            dispatch({ type: YOUTUBE_SUBSCRIBERS_REJECTED });
        });
};

export const fetchTopTrendsData = (dispatch, data) => {
    let params = new URLSearchParams();
    let { start_date, end_date } = getDateParamsTrends(data.duration, data.start_date, data.end_date);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("locations", data.locations.length > 0 ? data.locations : data.locations.split());
    params.append("sort_by", data.sort_by);

    //let url = `https://api2.radarr.com/v7/twitter-trends/getTopTrends?access-token=${getAccessToken()}`;
    const url = getUrl("twitter_trends_get_top_trends");

    dispatch({ type: TOP_TRENDS_PENDING });
    axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: params,
    })
        .then((res) => {
            dispatch({
                type: TOP_TRENDS_FULFILLED,
                payload: res.data.data,
            });
        })
        .catch((err) => {
            console.log(err);
            dispatch({ type: TOP_TRENDS_REJECTED });
        });
};

export const fetchTrendsOverTime = (dispatch, data) => {
    let params = new URLSearchParams();

    let { start_date, end_date } = getDateParamsTrends(data.duration, data.start_date, data.end_date);
    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("locations", data.locations.length > 0 ? data.locations : data.locations.split());
    params.append("sort_by", data.sort_by);
    params.append("interval", data.aggs_val);

    //let url = `https://api2.radarr.com/v7/twitter-trends/getTopTrends/overtime?access-token=${getAccessToken()}`;
    const url = getUrl("twitter_trends_get_top_trends_overtime");

    dispatch({ type: TRENDS_OVER_TIME_PENDING });
    axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: params,
    })
        .then((res) => {
            dispatch({
                type: TRENDS_OVER_TIME_FULFILLED,
                payload: res.data,
            });
        })
        .catch((err) => {
            console.log(err);
            dispatch({ type: TRENDS_OVER_TIME_REJECTED });
        });
};

export const fetchTrendsOverTimeUsingComparison = (dispatch, data) => {
    let params = new URLSearchParams();

    params.append("comparison_id", data);

    //let url = `https://api2.radarr.com/v7/twitter-trends/getTopTrends/overtime/usingComparison?access-token=${getAccessToken()}`;
    const url = getUrl("twitter_trends_get_top_trends_overtime_using_comparison");

    dispatch({ type: TRENDS_OVER_TIME_PENDING });
    axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: params,
    })
        .then((res) => {
            dispatch({
                type: TRENDS_OVER_TIME_FULFILLED,
                payload: res.data,
            });
        })
        .catch((err) => {
            console.log(err);
            dispatch({ type: TRENDS_OVER_TIME_REJECTED });
        });
};

export const getComparisons = (dispatch) => {
    let url = `https://api2.radarr.com/v7/twitter-trends/getComparisons?access-token=v3-b96c7fe108c7a6be5910a3ec0d82391c`;
    dispatch({ type: GET_COMPARISONS_PENDING });
    axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch({
                    type: GET_COMPARISONS_FULFILLED,
                    payload: res.data,
                });
            } else {
                dispatch({ type: GET_COMPARISONS_REJECTED });
            }
        })
        .catch((err) => {
            console.log(err);
            dispatch({ type: GET_COMPARISONS_REJECTED });
        });
};

export function fetchSavedSearchKeywords(country) {
    let url = `https://api2.radarr.com/v7/google-trends/hot-trend?access-token=${getAccessToken()}`;

    let req = axios({
        method: "post",
        url,
        headers: {
            "Content-Type": "application/json",
        },
        data: { country_ids: country },
    }).then((res) => res.data);

    return {
        type: SAVED_SEARCHES_KEYWORD,
        payload: req,
    };
}

export const googleTrendsForKeywords = (keywords, country) => {
    let params = new URLSearchParams();
    params.append("keywords", keywords.join(","));
    params.append("geo", country);
    const start_date = moment().subtract(30, "days").format("YYYY-MM-DD");
    params.append("start_date", start_date);
    const end_date = moment().format("YYYY-MM-DD");
    params.append("end_date", end_date);

    let url = `https://api2.radarr.com/v0/google-trends?keywords=${keywords}&start_date=${start_date}&end_date=${end_date}&geo=${country}&access-token=${getAccessToken()}`;
    let req = axios({
        method: "get",
        url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        // data: params,
    }).then((res) => res.data);

    return {
        type: GOOGLE_TRENDS_FOR_KEYWORDS,
        payload: req,
    };
};

export const fetchHotSearchesData = (dispatch, country) => {
    let params = new URLSearchParams();
    params.append("pn", country);

    let url = `https://api2.radarr.com/v7/google-trends/hot-search?access-token=${getAccessToken()}`;

    dispatch({ type: HOT_SEARCHES_PENDING });
    axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: params,
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch({
                    type: HOT_SEARCHES_FULFILLED,
                    payload: res.data.data.channel.item,
                });
            } else {
                dispatch({ type: HOT_SEARCHES_REJECTED });
            }
        })
        .catch((err) => {
            console.log(err);
            dispatch({ type: HOT_SEARCHES_REJECTED });
        });
};

export const fetchLocalTwitterTrends = (dispatch, country) => {
    let params = new URLSearchParams();
    params.append("country_id", country);

    //let url = `https://api2.radarr.com/v7/twitter-trends/getTopTrends-legacy?access-token=${getAccessToken()}`;
    const url = getUrl("twitter_trends_get_top_trends_legacy");

    dispatch({ type: LOCAL_TWITTER_TRENDS_PENDING });
    axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: params,
    })
        .then((res) => {
            dispatch({
                type: LOCAL_TWITTER_TRENDS_FULFILLED,
                payload: res.data.response.data.raw,
            });
        })
        .catch((err) => {
            console.log(err);
            dispatch({ type: LOCAL_TWITTER_TRENDS_REJECTED });
        });
};

export const fetchGlobalTwitterTrends = (dispatch) => {
    let params = new URLSearchParams();

    params.append("country_id", "6cb675f9-a789-11e4-a34f-74867a1157ba");

    //let url = `https://api2.radarr.com/v7/twitter-trends/getTopTrends-legacy?access-token=${getAccessToken()}`;
    const url = getUrl("twitter_trends_get_top_trends_legacy");

    dispatch({ type: GLOBAL_TWITTER_TRENDS_PENDING });
    axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: params,
    })
        .then((res) => {
            dispatch({
                type: GLOBAL_TWITTER_TRENDS_FULFILLED,
                payload: res.data.response.data.raw,
            });
            return res;
        })
        .catch((err) => {
            console.log(err);
            dispatch({ type: GLOBAL_TWITTER_TRENDS_REJECTED });
        });
};
